const { REACT_APP_API_URL } = process.env;

export const GRAPHQL_ENDPOINT = `${REACT_APP_API_URL}/graphql`;
export const SIGNIN_ENDPOINT = `${REACT_APP_API_URL}/auth/client/signin`;
export const SIGNUP_ENDPOINT = `${REACT_APP_API_URL}/auth/client/signup`;
export const USER_VERIFICATION_ENDPOINT = `${REACT_APP_API_URL}/auth/client/user_verification`;
export const VERIFICATION_EMAIL_ENDPOINT = `${REACT_APP_API_URL}/auth/client/verification_email`;
export const PASSWORD_RESET_EMAIL_ENDPOINT = `${REACT_APP_API_URL}/auth/client/password_reset_email`;
